import { atom } from 'recoil';

export interface JobTitleAtom extends Record<string, string[] | string> {
	titles: string;
	seniorityLevels: string[];
	companies: string[];
	boards: string[];
	managements: string[];
	workStations: string[];
	// requirementTypes: string[];
	// educationalRequirements: string[];
	// professionalRequirements: string[];
	// otherRequirements: string[];
}

export const jobTitleAtom = atom<JobTitleAtom>({
	key: 'jobTitle',
	default: {
		titles: '',
		seniorityLevels: [],
		companies: [],
		boards: [],
		managements: [],
		workStations: [],
		// requirementTypes: [],
		// educationalRequirements: [],
		// professionalRequirements: [],
		// otherRequirements: [],
	},
});
